import { Container, Grid, Box, Flex } from 'components/box';
import ProductListing from 'components/_shared/widgets/product-listing';
import { ListingItem } from 'components/_shared/widgets/product-listing/types';
import { useState, useEffect, memo } from 'react';
import CategoriesBar from './categories-bar';
import SectionTitle from 'components/_shared/elements/section-title';
import { filterProducts } from 'components/_pages/gift-vouchers/util';
import { CATEGORY_ALL } from './constants';
import { PageTitle, ParagraphText, Text } from 'components/typography';
import { css } from '@emotion/react';

const GiftVoucherShopPage = memo(
  ({
    categories,
    giftVouchersItems,
  }: {
    categories?: string[];
    giftVouchersItems: ListingItem[];
  }) => {
    const [selectedCategory, setSelectedCategory] = useState(CATEGORY_ALL);
    const [filteredProducts, setFilteredProducts] = useState<ListingItem[]>(
      filterProducts({
        selectedCategory,
        giftVouchersProps: giftVouchersItems,
      })
    );

    const [showMoreButton, setShowMoreButton] = useState(false);

    useEffect(() => {
      if (giftVouchersItems && selectedCategory) {
        setFilteredProducts(
          filterProducts({
            selectedCategory,
            giftVouchersProps: giftVouchersItems,
          })
        );
      }
    }, [selectedCategory, giftVouchersItems]);

    return (
      <>
        {categories && categories.length > 0 && giftVouchersItems && (
          <CategoriesBar
            categoriesList={categories}
            selectedCategory={selectedCategory}
            showMoreButton={showMoreButton}
            setShowMoreButton={setShowMoreButton}
            setSelectedCategory={setSelectedCategory}
          />
        )}

        <Container py="3">
          <Box mt="5">
            <Box pb="4">
              <SectionTitle title="Choose Your Gift Voucher" pageTitle />
            </Box>

            {filteredProducts.length > 0 ? (
              <Grid py="1" px="0">
                <ProductListing items={filteredProducts} />
              </Grid>
            ) : (
              <Text>
                We couldn&apos;t load any gift vouchers, please try again later
              </Text>
            )}
          </Box>
          <Box
            pt={5}
            my={5}
            color="black"
            css={css`
              border-top: 1px solid #99abb9;
            `}
          >
            <Flex
              flexDirection="column"
              css={theme => css`
                gap: ${theme.space[3]}px;
              `}
            >
              <PageTitle textAlign="left">About Gift Vouchers</PageTitle>
              <ParagraphText lineHeight={1.8}>
                Looking for a lekker way to make someone&apos;s day? Our{' '}
                <strong>gift cards, vouchers, and gift certificates</strong> on
                OneDayOnly.co.za are the ultimate solution. Perfect for
                everything from a simple “Thanks, Pal” to a cheeky “You&apos;re
                Such an S.O.B. (Super Outstanding Boss),” our selection is
                packed with humour, charm, and loads of South African flair.
              </ParagraphText>
              <ParagraphText lineHeight={1.8}>
                Whether it&apos;s a “Happy Birthday” voucher or a “Thanks for
                Being Awesome” gift card that delivers heartfelt appreciation,
                these gems cover every occasion. Give a gift card that&apos;s as
                versatile as it is memorable—something to suit everyone, whether
                they&apos;re as cool as a summer braai or as reliable as that
                trusty winter heater.
              </ParagraphText>
              <ParagraphText lineHeight={1.8}>
                From saying cheers to the low-key heroes in your life to
                celebrating with the friend who&apos;d happily declare it “the
                last day of diets,” these gift vouchers cover all the bases (and
                then some). Let&apos;s face it, sometimes words aren&apos;t
                enough, but a voucher that says, “Thanks for Being Awesome”
                definitely does the trick.
              </ParagraphText>
              <ParagraphText lineHeight={1.8}>
                Gift vouchers are a versatile and fun form of gift-giving
                without the risk of them not liking the braai tongs you got
                them… awkward! Whether it&apos;s for birthdays, thank-yous, or
                farewells, there&apos;s something here for everyone who needs a
                little boost. Plus, with these, you can finally give a gift that
                feels personal and lekker without spending hours in the mall.
              </ParagraphText>
              <ParagraphText lineHeight={1.8}>
                So, ready to put a smile on someone&apos;s dial? Browse our
                collection now and get ready to score some serious brownie
                points – no receipts are required.
              </ParagraphText>
              <ParagraphText lineHeight={1.8}>
                With OneDayOnly.co.za, it&apos;s never been easier to find a{' '}
                <strong>gift voucher</strong> that&apos;s guaranteed to make
                them smile. So go on, browse our collection, and send a gift
                that does the talking for you—no awkward mall trips required,
                just pure, tongue-in-cheek joy delivered straight to their
                inbox.
              </ParagraphText>
            </Flex>
          </Box>
        </Container>
      </>
    );
  }
);

export default GiftVoucherShopPage;
